// Shared Category tag colors so "Direct" / "Indirect" / "Other/Fixed" render identically
// across every Crewing Analytics table (Location, Hours, Employee, etc.).
export const CATEGORY_TAG_STYLES: Record<string, { backgroundColor: string; color: string }> = {
  direct: { backgroundColor: '#DCE9FC', color: '#0B5FC6' },
  indirect: { backgroundColor: '#EDEFF2', color: '#4B5563' },
  'other/fixed': { backgroundColor: '#FEF3C7', color: '#B45309' },
  other: { backgroundColor: '#FEF3C7', color: '#B45309' },
};

export const DEFAULT_CATEGORY_TAG_STYLE = { backgroundColor: '#F0F0F0', color: '#4B4B4B' };

export const getCategoryTagStyle = (value: string) =>
  CATEGORY_TAG_STYLES[value.toLowerCase()] ?? DEFAULT_CATEGORY_TAG_STYLE;
